import http from '@/server/httpServer.js'

/**
 * 调解员
 */

// 根据案件进度查询各进度的调解数量
export const getMediationCountByCaseProgress = (data) => {
    return http({ url: '/userGateway/personalCenter/getMediationCountByCaseProgress' }, data)
}

export const getMediationListPage = (data) => {
        return http({ url: '/userGateway/personalCenter/getMediationListPage' }, data)
    }
    // 案件详情
export const getMediationInfo = (data) => {
    return http({ url: '/gzzc/mediation/getMediationInfo' }, data)
}

// 编辑案件纠纷信息
export const editCaseDisputeInfo = (data) => {
        return http({ url: '/gzzc/case/editCaseDisputeInfo' }, data)
    }
    // 区域
export const searchAreasInfo = (data) => {
    return http({ url: '/userGateway/area/searchAreasInfo' }, data)
}

export const assignMediatorAgain = (data) => {
    return http({ url: '/gzzc/case/assignMediatorAgain' }, data)
}

// 调解成功
export const mediateSuccess = (data) => {
        return http({ url: '/gzzc/case/mediateSuccess' }, data)
    }
    // 调解失败
export const mediateFail = (data) => {
        return http({ url: '/gzzc/case/mediateFail' }, data)
    }
    /* 撤回调解 */
export const retractCase = (data) => {
    return http({ url: '/gzzc/case/retractCase' }, data)
}

// 获取协议书
export const getProtocolBook = (data) => {
    return http({ url: '/gzzc/document/getProtocolBook' }, data)
}

// 调解员获取无异议调解方案
export const getMediationScheme = (data) => {
    return http({ url: '/gzzc/document/getMediationScheme' }, data)
}

// 保存协议书
export const saveProtocolBook = (data) => {
    return http({ url: '/gzzc/document/saveProtocolBook' }, data)
}

// 发送协议书
export const sendMediationProtocolBook = (data) => {
    return http({ url: '/gzzc/document/sendMediationProtocolBook' }, data)
}

// 保存承诺书
export const savePromise = (data) => {
    return http({ url: '/gzzc/document/savePromise' }, data)
}

// 视频记录
export const getVideoList = (data) => {
    return http({ url: '/gzzc/caseMeeting/getVideoList' }, data)
}

// 查看调解笔录接口
export const viewMediationRecord = (data) => {
    return http({ url: '/gzzc/mediationRecord/viewMediationRecord' }, data)
}

// 发送调解笔录接口
export const sendMediationRecord = (data) => {
    return http({ url: '/gzzc/mediationRecord/sendMediationRecord' }, data)
}

// 保存调解笔录接口
export const saveMediationRecord = (data) => {
        return http({ url: '/gzzc/mediationRecord/saveMediationRecord' }, data)
    }
    // 查询某用户对调解文书的签名状态
export const getMediationClerkConfirm = (data) => {
        return http({ url: '/gzzc/clerkConfirm/getMediationClerkConfirm' }, data)
    }
    // 保存会议记录态
export const saveCaseMeeting = (data) => {
    return http({ url: '/gzzc/caseMeeting/saveCaseMeeting' }, data)
}

// 调解 保存上传文件，电子卷宗
export const saveUpFilessaveCaseMeeting = (data) => {
    return http({ url: '/gzzc/caseMeeting/saveUpFiles' }, data)
}

// 邀请观摩人
export const inviteSendSms = (data) => {
    return http({ url: '/gzzc/caseMeeting/inviteSendSms' }, data)
}

// 卷宗列表
export const queryDossierList = (data) => {
    return http({ url: '/gzzc/lawCaseDossier/queryDossierList' }, data)
}

// 通过案件id查询生成卷宗
export const getGenerateFile = (data) => {
    return http({ url: '/gzzc/lawCaseDossier/getGenerateFile' }, data)
}

// 卷宗文件上传
export const dossierUpload = (data) => {
    return http({ url: '/gzzc/lawCaseDossier/dossierUpload' }, data)
}

// 卷宗文件上传(更新后)
export const batchFilesUpload = (data) => {
    return http({ url: '/gzzc/file/batchFilesUpload' }, data)
}

// 卷宗材料多文件上传
export const batchDossierFilesUpload = (data) => {
    return http({ url: '/gzzc/file/batchDossierFilesUpload' }, data)
}

// 调解文件材料类型
export const materialType = (data) => {
    return http({ url: '/gzzc/file/materialType' }, data)
}

// 卷宗数据回显
export const displayFileDossier = (data) => {
    return http({ url: '/gzzc/lawCaseDossier/displayFileDossier' }, data)
}

// 通过案件id查询案件对应文件
export const getLawAttachmentList = (data) => {
    return http({ url: '/gzzc/lawCaseDossier/getLawAttachmentList' }, data)
}

// 新增或修改案件人
export const saveCaseUser = (data) => {
    return http({ url: '/gzzc/case/saveCaseUser' }, data)
}

// 删除案件人
export const deleteCaseUser = (data) => {
    return http({ url: '/gzzc/case/deleteCaseUser' }, data)
}

// 卷宗文件下载
export const dossierDownload = (data) => {
    return http({ url: '/gzzc/lawCaseDossier/dossierDownload' }, data)
}

// 撤销卷宗信息
export const rejectDossier = (data) => {
    return http({ url: '/gzzc/lawCaseDossier/rejectDossier' }, data)
}

// 提交卷宗审核
export const submitLawDossier = (data) => {
    return http({ url: '/gzzc/lawCaseDossier/submitLawDossier' }, data)
}

// 进度详情
export const queryLawProgressList = (data) => {
        return http({ url: '/gzzc/lawCaseDossier/queryLawProgressList' }, data)
    }
    // 视频期间删除文件
export const delFile = (data) => {
    return http({ url: '/gzzc/lawCaseDossier/delFile' }, data)
}


// 获取司法确认申请书
export const getJudicialConfirmBook = (data) => {
    return http({ url: '/gzzc/judicialConfirm/getJudicialConfirmBook' }, data)
}

// 保存司法确认申请书
export const saveJudicialConfirmBook = (data) => {
    return http({ url: '/gzzc/judicialConfirm/saveJudicialConfirmBook' }, data)
}

// 发送司法确认申请书
export const sendJudicialConfirmBook = (data) => {
    return http({ url: '/gzzc/judicialConfirm/sendJudicialConfirmBook' }, data)
}

// 法院json地址
export const court = (data) => {
        return http({ url: '/arbit/court/court.json', method: 'get' }, data)
    }
    /* 申请诉讼 */
export const getSuitBaseInfo = (data) => {
    return http({
        url: '/arbit/suit/getSuitBaseInfo',
        method: 'post'
    }, data)
}

/* 获取案由 - 申请诉讼 */
export const getlawCause = (data, jsonfile) => {
    return http({
        url: '/arbit/lawCause/' + jsonfile,
        method: 'get'
    }, data)
}

// 当事人同意协议书
export const agreeProtocolBook = (data) => {
    return http({ url: '/gzzc/document/agreeProtocolBook' }, data)
}

// 当事人拒绝协议书
export const refuseProtocolBook = (data) => {
    return http({ url: "/gzzc/clerkConfirm/refuseProtocolBook" }, data);
}

// 获取当前时间戳
export const getCurrentTimestamp = (data) => {
    return http({ url: '/basicGateway/tool/getCurrentTimestamp', method: 'get' }, data)
}

// 保存新会议记录
export const saveNewCaseMeeting = (data) => {
    return http({ url: '/gzzc/caseMeeting/saveNewCaseMeeting' }, data)
}

// 获取字典信息
export const searchDictionaryInfo = (data) => {
    return http({ url: '/userGateway/dictionary/searchDictionaryInfo' }, data)
}

// 选择协助调解员列表
export const getAssistMediatorListPage = (data) => {
    return http({ url: '/userGateway/servicePerson/getAssistMediatorListPage' }, data)
}

// 查询角色用户信息
export const searchRoleUserInfo = (data) => {
    return http({ url: '/userGateway/user/searchRoleUserInfo' }, data)
}

// 邀请临时协助调解员
export const saveTempMediator = (data) => {
    return http({ url: '/gzzc/caseMeeting/saveTempMediator' }, data)
}

// 邀请协助调解员
export const inviteMediator = (data) => {
    return http({ url: '/gzzc/case/inviteMediator' }, data)
}

// 查看协助调解员
export const queryMediatorHelp = (data) => {
        return http({ url: '/gzzc/case/queryMediatorHelp' }, data)
    }
    //调解距离情绪识别
export const recordEmotionRecognition = (data) => {
        return http({ url: '/gzzc/caseMeeting/meetingEmotion' }, data)
    }
    //获取所有文书
export const getAllDocument = (data) => {
    return http({ url: '/gzzc/document/getAllDocument' }, data)
}